import script from "./SchoolList.vue?vue&type=script&setup=true&lang=js"
export * from "./SchoolList.vue?vue&type=script&setup=true&lang=js"

import "./SchoolList.vue?vue&type=style&index=0&id=cd0806e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd0806e0"]])

export default __exports__